function toNumber(value) {
    return Number(value) || 0;
}

export function getReportMediaStats(reportOrStats, fallbackMediaCount) {
    const stats = reportOrStats && reportOrStats.stats ? reportOrStats.stats : (reportOrStats || {});
    const mediaCount = fallbackMediaCount !== undefined && fallbackMediaCount !== null
        ? toNumber(fallbackMediaCount)
        : toNumber(stats.media_count);

    return {
        mediaCount,
        sentCount: toNumber(stats.sent_media_count),
        processedCount: toNumber(stats.processed_media_count),
        processingCount: toNumber(stats.pending_media_count),
        storageWaitCount: toNumber(stats.temp_media_count),
        failedCount: toNumber(stats.telegram_failed_media_count),
        shiftNotFoundCount: toNumber(stats.shift_not_found_media_count),
        sourceMissingCount: toNumber(stats.source_missing_media_count)
    };
}

export function hasUnsentPhotosToResend(reportOrStats) {
    const stats = getReportMediaStats(reportOrStats);
    return stats.processedCount > 0 || stats.failedCount > 0;
}

export function buildMediaDeliveryBadges(reportOrStats, fallbackMediaCount) {
    const stats = getReportMediaStats(reportOrStats, fallbackMediaCount);

    if (!stats.mediaCount) {
        return [{key: 'empty', text: 'фото не загружены', variant: 'muted'}];
    }

    const badges = [{
        key: 'sent',
        text: `доставлено ${stats.sentCount} из ${stats.mediaCount}`,
        variant: stats.sentCount >= stats.mediaCount ? 'success' : 'muted'
    }];

    if (stats.processedCount) {
        badges.push({key: 'processed', text: `к отправке ${stats.processedCount}`, variant: 'warning'});
    }
    if (stats.processingCount) {
        badges.push({key: 'processing', text: `обрабатываются ${stats.processingCount}`, variant: 'info'});
    }
    if (stats.storageWaitCount) {
        badges.push({
            key: 'storage_wait',
            text: `ожидают хранилище ${stats.storageWaitCount}`,
            variant: 'warning'
        });
    }
    if (stats.failedCount) {
        badges.push({key: 'failed', text: `сбой доставки ${stats.failedCount}`, variant: 'danger'});
    }
    if (stats.shiftNotFoundCount) {
        badges.push({key: 'shift_not_found', text: `ошибка привязки ${stats.shiftNotFoundCount}`, variant: 'danger'});
    }
    if (stats.sourceMissingCount) {
        badges.push({key: 'source_missing', text: `исходник не найден ${stats.sourceMissingCount}`, variant: 'danger'});
    }

    return badges;
}
